import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [
    { name: 'الرئيسية', path: '/' },
    { name: 'عن المقاطعة', path: '/about' },
    { name: 'المميزات', path: '/services' },
    { name: 'الوظائف', path: '/jobs' },
    { name: 'الهوية', path: '/id-generator' },
    { name: 'الرادار', path: '/radar' },
    { name: 'القوانين', path: '/laws' },
    { name: 'المعرض', path: '/gallery' },
    { name: 'تواصل معنا', path: '/contact' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 glass-panel border-b border-white/10 text-white">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple tracking-widest lg:w-1/4"
        >
          مقاطعة الراية
        </motion.div>

        <ul className="hidden lg:flex justify-center items-center gap-5 lg:w-2/4">
          {navItems.map((item, index) => (
            <motion.li
              key={item.name}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <Link
                to={item.path}
                className={`hover:text-neon-cyan transition-colors duration-200 text-sm font-bold focus:outline-none ${
                  location.pathname === item.path ? 'text-neon-cyan' : 'text-white'
                }`}
              >
                {item.name}
              </Link>
            </motion.li>
          ))}
        </ul>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.25 }}
          className="hidden lg:flex items-center justify-center gap-2 lg:w-1/4 pl-4"
        >
          <a
            href="https://discord.gg/x5"
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 bg-[#5865F2]/10 text-[#5865F2] border border-[#5865F2]/50 hover:bg-[#5865F2] hover:text-white rounded-xl font-bold transition-colors duration-200 text-sm"
          >
            ديسكورد
          </a>
          <a
            href="fivem://connect/cfx.re/join/bdx43gd"
            className="px-4 py-2 bg-neon-cyan/10 text-neon-cyan border border-neon-cyan/50 hover:bg-neon-cyan hover:text-black rounded-xl font-bold transition-colors duration-200 text-sm"
          >
            العب الآن
          </a>
        </motion.div>

        <div className="lg:hidden flex items-center">
          <button
            type="button"
            onClick={() => setIsOpen((open) => !open)}
            className="text-white hover:text-neon-cyan focus:outline-none transition-colors"
            aria-label="فتح القائمة"
          >
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
        >
          <ul className="flex flex-col items-center gap-4 py-6 px-4">
            {navItems.map((item) => (
              <li key={item.name} className="w-full text-center">
                <Link
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block w-full py-2 transition-colors duration-200 text-lg font-bold ${
                    location.pathname === item.path ? 'text-neon-cyan' : 'text-white'
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
            <div className="flex flex-col items-center gap-3 mt-4 w-full px-4">
              <a
                href="https://discord.gg/x5"
                target="_blank"
                rel="noreferrer"
                className="w-full text-center px-4 py-3 bg-[#5865F2]/10 text-[#5865F2] border border-[#5865F2]/50 hover:bg-[#5865F2] hover:text-white rounded-xl font-bold transition-colors duration-200"
              >
                ديسكورد
              </a>
              <a
                href="fivem://connect/cfx.re/join/bdx43gd"
                className="w-full text-center px-4 py-3 bg-neon-cyan/10 text-neon-cyan border border-neon-cyan/50 hover:bg-neon-cyan hover:text-black rounded-xl font-bold transition-colors duration-200"
              >
                العب الآن
              </a>
            </div>
          </ul>
        </motion.div>
      )}
    </nav>
  );
}
